<template>
    <modal :value="open" @input="emitClose" title="Tag Editor" @hide="emitClose" @show="emitShow">
        <p>Update your tags for this item, new tags (shown darker) will be created for you</p>
        <p>Press enter to create and separate your tags</p>

        <api-errors :errors="errors" />
        <autocomplete-tags :current-tags="current_tags" :user-tags="userTagsFlat" @tag-update="updateTags" />
        <div slot="footer">
            <button type="button" class="btn btn-default" @click="emitClose">
                Close
            </button>
            <submit-tags
                    :submit-url="submitUrl"
                    :tags="current_tags"
                    @error="setErrors"
                    @tags-saved="updateSavedTags"
            />
        </div>
    </modal>
</template>

<script>
import Modal from 'uiv/src/components/modal/Modal.vue'
import autocompleteTag from '@/tags/AutoCompleteTag.vue'
import submitTags from '@/tags/SubmitTags.vue'
import { flatten } from 'src/lib/utils.js'
import apiErrors from '@/ApiErrorDisplay.vue'

export default {
    components: {
        'modal': Modal,
        'autocomplete-tags': autocompleteTag,
        'submit-tags': submitTags,
        'api-errors': apiErrors,
    },
    props: {
        itemTags: {
            type: String,
            required: true,
        },
        userTags: {
            type: String,
            required: true,
        },
        submitUrl: {
            type: String,
            required: true,
        },
        open: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        current_tags: [],
        real_tags: [],
        user_tags: [],
        errors: {},
        selected: '',
    }),
    computed: {
        userTagsFlat: function() {
            return flatten(this.user_tags, 'name')
        }
    },
    created: function() {
        let saved_tags = JSON.parse(this.itemTags)
        for (let tag of saved_tags) {
            tag['name'] = tag['tag__name']
            tag['id'] = tag['tag__id']
        }
        this.current_tags = flatten(saved_tags, 'name')

        this.real_tags = [...this.current_tags]
        this.user_tags = JSON.parse(this.userTags)
        this.$emit('saved-tags', saved_tags)
    },
    methods: {
        updateTags: function(tags) {
            this.current_tags = tags
        },
        updateSavedTags: function(tags) {
            for (let tag of tags) {
                if (!this.userTagsFlat.includes(tag['name'])) {
                    this.user_tags.push(tag)
                }
            }
            this.real_tags = [...this.current_tags]

            this.$emit('saved-tags', tags)
            this.emitClose()
        },
        emitClose: function() {
            this.current_tags = []
            this.$emit('hide')
        },

        emitShow:function () {
            this.current_tags = [...this.real_tags]
        },
        setErrors: function(errors) {
            this.errors = errors
        }
    },
}
</script>
